
<div style="overflow:hidden;text-overflow:ellipsis;" [id]="this.id">
    <span [ngbPopover]="value" container="body" popoverClass="CXoneMgtPopover" [placement]="this.getPopoverPosition()" triggers="mouseenter:mouseleave" [openDelay]="400"
          [disablePopover]="params.value === null || params.value === '' || this.hidePopover() " class="textContent" [innerHTML]="value | boldText:searchFilter:minSearchLength" >
    </span>
    <span *ngIf="type == 2 && params.text" class="ml-1">
        <svg class="icon-20 fill-whaleTail clickable" [ngbPopover]="params.text" container="body" popoverClass="CXoneMgtPopover calcPopover" placement="top-left" triggers="mouseenter:mouseleave" [openDelay]="400">
            <use href="../App_Themes/CXone/icons/calculated_metrics.svg#calculated_metrics"></use>
        </svg>
    </span>
</div>
